import { IconCopy, IconDotsVertical, IconTrash } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { useState } from 'react';
import {
    Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
} from 'reactstrap';
import { NSButton } from 'bricks';
import './ActivityActionsMenu.scss';

type ActivityActionsMenuProps = {
    onDuplicate: () => void;
    onDelete: () => void;
    dataTestIdPrefix: string;
};

const ActivityActionsMenu = ({ onDuplicate, onDelete, dataTestIdPrefix }: ActivityActionsMenuProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(prev => !prev)} direction="down">
            <DropdownToggle tag="button" className="btn p-0 border-0 bg-transparent">
                <NSButton
                    color="secondary"
                    size="sm"
                    icon={IconDotsVertical}
                    ariaLabel="Activity actions"
                    className="ActivityActionsMenu__toggle"
                />
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem onClick={onDuplicate} className="text-white" data-testid={`${dataTestIdPrefix}-duplicate`}>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Duplicate task</span>
                        <NSIcon className="ml-1" icon={IconCopy} />
                    </div>
                </DropdownItem>
                <DropdownItem onClick={onDelete} className="text-white" data-testid={`${dataTestIdPrefix}-delete`}>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Delete task</span>
                        <NSIcon className="ml-1" icon={IconTrash} />
                    </div>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default ActivityActionsMenu;
